/* global Event */
import React, { FunctionComponent } from 'react';
import { ScrollProvider, IPosition } from 'app/components/scroll/ScrollContext';
import {
  dispatchEvent,
  getElementById,
  getInnerWindowSize,
  getWindow,
  getWindowScrollPosition,
  getWindowScrollSize,
  scrollWindow,
} from 'app/utils/env';

const window = getWindow();

const deps = {
  scrollEmitter: window,
  getPosition: getWindowScrollPosition,
  getBounds: () => {
    const { width, height } = getInnerWindowSize();
    return {
      width,
      height,
      top: 0,
      left: 0,
      right: width,
      bottom: height,
    };
  },
  getScrollSize: () => {
    return getWindowScrollSize();
  },
  scrollTo: (position: Partial<IPosition>) => {
    const current = getWindowScrollPosition();
    const x = position.x !== undefined ? position.x : current.x;
    const y = position.y !== undefined ? position.y : current.y;
    scrollWindow(x, y);
    try {
      dispatchEvent(new Event('scroll')); // notify that we scrolled programatically
    } catch (error) {
      // This throws in IE11
    }
  },
  findElementByAnchor: (anchor: string) => {
    return getElementById(anchor);
  },
};

const WindowScrollProvider: FunctionComponent = (props) =>
  <ScrollProvider
    {...props}
    {...deps}
    scrollId="window"
  />;

export default WindowScrollProvider;
